// react
import { createContext, Dispatch, SetStateAction } from 'react';

// types
import {
	Pagination,
	TransactionGroup,
	TransactionWithDaEquivalent,
	Account,
} from '../../../../../@types';
import { FiltersValues, GetTransactionsProps } from './Soe';

// utils
import { defaultPagination } from '../../../../../utils/defaults';

// ui
import { SortableListItem } from '../../../../ui/BtnSortableList/BtnSortableList';
import { FilterProps } from '../../../../ui/Filters/Filters';

export interface ContextSoeAccountsProps {
	accounts: Account[];
	setAccounts: Dispatch<SetStateAction<Account[]>>;
}

export const ContextSoeAccounts = createContext<ContextSoeAccountsProps>({
	accounts: [],
	setAccounts: () => {
		console.log('SET ACCOUNTS');
	},
});

export interface ContextSoeFiltersProps {
	filters: FilterProps[];
	filtersValues: FiltersValues;
	setFiltersValues: Dispatch<SetStateAction<FiltersValues>>;
}

export const ContextSoeFilters = createContext<ContextSoeFiltersProps>({
	filters: [],
	filtersValues: {},
	setFiltersValues: () => {
		console.log('SET FILTERS VALUES');
	},
});

export interface ContextSoeTransactionsProps {
	columns: SortableListItem[];
	getTransactions: ({ pagination, tab }: GetTransactionsProps) => void;
	headerSelections: SortableListItem[];
	isLoading: boolean;
	pagination: Pagination;
	setColumns: Dispatch<SetStateAction<SortableListItem[]>> | undefined;
	setHeaderSelections: Dispatch<SetStateAction<SortableListItem[]>>;
	setPagination: Dispatch<SetStateAction<Pagination>>;
	setTransactions: Dispatch<SetStateAction<TransactionWithDaEquivalent[]>>;
	setTransactionsGrouping: Dispatch<SetStateAction<TransactionGroup[]>>;
	setTransactionsUnchecked: Dispatch<SetStateAction<number[]>>;
	transactions: TransactionWithDaEquivalent[];
	transactionsGrouping: TransactionGroup[];
	transactionsUnchecked: number[];
}

export const ContextSoeTransactions = createContext<ContextSoeTransactionsProps>({
	columns: [],
	getTransactions: ({ pagination, tab }) => {
		console.log('GET TRANSACTIONS');
	},
	headerSelections: [],
	isLoading: false,
	pagination: defaultPagination,
	setColumns: () => {
		console.log('SET COLUMNS');
	},
	setHeaderSelections: () => {
		console.log('SET HEADER SELECTIONS');
	},
	setPagination: () => {
		console.log('SET PAGINATION');
	},
	setTransactions: () => {
		console.log('SET TRANSACTIONS');
	},
	setTransactionsGrouping: () => {
		console.log('SET TRANSACTIONS GROUPING');
	},
	setTransactionsUnchecked: () => {
		console.log('SET TRANSACTIONS UNCHECKED');
	},
	transactions: [],
	transactionsGrouping: [],
	transactionsUnchecked: [],
});
